import { mergeStyles } from '@cian/utils';
import * as React from 'react';

import styles from './index.css';
import { IBreadcrumbSchema } from '../../types';
import { getMicrodata } from '../../utils/microdata';

export interface IBreadcrumbsOwnProps {
  linkLight?: boolean;
}
export interface IBreadcrumbsStoreProps {
  breadcrumbs: IBreadcrumbSchema[] | null;
}

export type TBreadcrumbs = IBreadcrumbsStoreProps & IBreadcrumbsOwnProps;

export class Breadcrumbs extends React.Component<TBreadcrumbs, {}> {
  public render() {
    const { breadcrumbs, linkLight } = this.props;
    if (!breadcrumbs) {
      return null;
    }

    const breadcrumbsToRender = breadcrumbs.map((breadcrumb, index) => {
      const url = breadcrumb.seo ? breadcrumb.seo.url : '';

      return (
        <span
          {...getMicrodata('ListItem')}
          className={styles['link_wrapper']}
          itemProp="itemListElement"
          key={`breadcrumb_${index}`}
        >
          {url ? (
            <a
              href={url}
              title={breadcrumb.title}
              itemProp="item"
              {...mergeStyles(styles['link'], linkLight && styles['link-light'])}
            >
              <span itemProp="name">{breadcrumb.title}</span>
            </a>
          ) : (
            <span itemProp="name" className={styles['link']}>
              {breadcrumb.title}
            </span>
          )}
          <meta itemProp="position" content={`${index + 1}`} />
        </span>
      );
    });

    return (
      <div className={styles['breadcrumbs']} {...getMicrodata('BreadcrumbList')}>
        {breadcrumbsToRender}
      </div>
    );
  }
}
